export function dataInRequest(params = {}) {
  return {
    type: '@excecaoMeta/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@excecaoMeta/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@excecaoMeta/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@excecaoMeta/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@excecaoMeta/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@excecaoMeta/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@excecaoMeta/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@excecaoMeta/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@excecaoMeta/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@excecaoMeta/RECORD_FILTERING',
    payload: { params },
  };
}